import React, { useEffect, useState } from "react";

export const useContainerRef = (
  ref: React.MutableRefObject<HTMLDivElement | null> | null
) => {
  const [current, setCurrent] = useState<HTMLDivElement>();

  useEffect(() => {
    if (ref?.current) {
      setCurrent(ref.current);
    }
  }, [ref]);

  return current;
};
